<template>
  <u-popover ref="popover" v-model="display" :target="target" :title="title" :trigger="trigger" :auto-placement="false" placement="bottom" @show="onShow" @hide="onHide">
    <template slot="popover">
      <slot></slot>
    </template>
  </u-popover>
</template>
<script>
export default {
  props: {
    target: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: 'outside-click'
    },
    width: {
      type: Number,
      required: false
    },
    position: {
      type: String,
      default: 'left'
    }
  },
  data: function () {
    return {
      display: false
    }
  },
  mounted () {
    // var vm = this

    // vm.$enquire.register('screen and (min-width:992px)', {
    //   unmatch: function () {
    //     if (vm.display) {
    //       vm.display = false
    //     }
    //   }
    // })
  },
  methods: {
  //   open: function () {
  //     this.$refs.popover.show()
  //   },
  //   close: function () {
  //     this.$refs.popover.hide()
  //   },
  //   onShow: function () {
  //     var vm = this

  //     var $popup = $(vm.$refs.popover.$refs.popup)
  //     $popup.addClass('u-popover') // will trigger nextTick to get popup width

  //     vm.$nextTick(function () {
  //       var $arrow = $popup.find('.arrow')
  //       var $target = $(vm.target)
  //       var offset = $target.offset()

  //       var targetTop = Math.ceil(offset.top)
  //       var targetLeft = Math.ceil(offset.left)
  //       var targetWidth = Math.ceil($target.outerWidth())
  //       var targetHeight = Math.ceil($target.outerHeight())
  //       var popupWidth = vm.width || (Math.ceil($popup.outerWidth()))
  //       $popup.css('z-index', 9999)

  //       if (vm.position === 'left') {
  //         $arrow.css('left', 23)

  //         $popup
  //           .css('top', targetTop + targetHeight + 10)
  //           .css('left', targetLeft)
  //           .css('display', 'inline-block')
  //           .css('width', popupWidth + 2)
  //           .css('min-width', popupWidth + 2)
  //       } else {
  //         $arrow.css('left', popupWidth - 13)

  //         $popup
  //           .css('top', targetTop + targetHeight + 10)
  //           .css('left', targetLeft + targetWidth - popupWidth)
  //           .css('display', 'inline-block')
  //           .css('width', popupWidth + 2)
  //           .css('min-width', popupWidth + 2)
  //       }
  //     })

  //     vm.$emit('open')
  //   },
  //   onHide: function () {
  //     this.$emit('close')
  //   }
  }
}
</script>
<style lang="scss">
// .u-popover {
//   &.popover {
//     padding: 0;
//     max-width: 100%;
//     // font-family: "Microsoft JhengHei", Verdana, sans-serif !important;
//     border-radius: 0;
//     box-shadow: 0 0;
//     z-index: 9999 !important;

//     .arrow {
//       top: 10px;
//       border: 0;

//       &:after {
//         content: "";
//         top: -25px;
//         border-width: 0 15px 15px 15px;
//         border-color: transparent transparent #f29b4f transparent;
//       }
//     }

//     .popover-title {
//       color: #fff;
//       background: #f29b4f;
//       padding: 15px;
//       font-size: 16px;
//       font-weight: bold;
//       line-height: 1.4em;
//       text-align: center;
//       border-radius: 0;
//       border: 0;
//     }

//     .popover-content {
//       margin: 0;
//       padding: 0;
//       line-height: 1.4;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/popover/Popover.vue